import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { actions as loginActions } from '/src/views/Auth/Login/redux';
import Spinner from "/src/components/UI/Spinner/Spinner";
import queryString from "query-string";
import BackToHomeBtn from '../UI/BackToHomeBtn';

const CrossAppLogoutListener = (props) => {
  const dispatch = useDispatch();
  const [showButton, setShowButton] = useState(false);

  const sendLogoutCompletedMessage =() =>{
    if(window.self !== window.top){
      window.parent.postMessage(
        {
          type: 'V2_LOGOUT_COMPLETED',
          source: 'v2',
        }, 
        '*'
      );
    }
  }

  useEffect(() => {
    const shouldLogoutInV2FromMSAL = queryString.parse(window.location.search).shouldLogoutInV2FromMSAL === "true";
    dispatch(loginActions.logout({shouldRedirectToHomePage: true, shouldLogoutInV2FromMSAL: shouldLogoutInV2FromMSAL}, {successCallback: sendLogoutCompletedMessage, errorCallback: sendLogoutCompletedMessage}))
    
    // Show button after 15 seconds
    const timer = setTimeout(() => {
      setShowButton(true);
    }, 15000);

    return () => clearTimeout(timer);
  }, []);

  if (showButton) {
    return (
      <BackToHomeBtn />
    );
  }

  return <Spinner />; 
};

export default CrossAppLogoutListener; 